import { render, staticRenderFns } from "./ResponsibleGamingContent.vue?vue&type=template&id=20257946"
import script from "./ResponsibleGamingContent.vue?vue&type=script&lang=js"
export * from "./ResponsibleGamingContent.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleGamingContent.vue?vue&type=style&index=0&id=20257946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports